import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Utilities } from 'src/app/services';
import { RegistrationDocument } from 'src/app/models/registration-document';
import { Document } from 'src/app/models';

@Component({
  selector: 'wm-compliance-docs',
  standalone: false,
  templateUrl: './compliance-docs-janus.component.html',
  styleUrls: ['./compliance-docs-janus.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ComplianceDocsJanusComponent implements OnInit {
  @Input() documents: any[] = [];
  @Input() workflowName!: string;
  @Input() parentId!: string;

  @Output() added = new EventEmitter<RegistrationDocument[]>();
  @Output() deleteRequested = new EventEmitter<string>();
  @Output() saved = new EventEmitter<any>();

  isOpen = true;
  showUploadSection = false;

  uploadedDocsBatch: Document[] = [];


  ngOnInit(): void { }

  toggleCard() {
    this.isOpen = !this.isOpen;
  }

  /* ================= TOGGLE UPLOAD ROW ================= */

  onUploadClick() {
    this.showUploadSection = true;
  }

  onCancelUpload() {
    this.showUploadSection = false;
    this.uploadedDocsBatch = [];
  }

  /* ================= WM-UPLOAD COMPLETE ================= */

  onUploadComplete(uploadedDocs: Document[]) {
    if (!uploadedDocs || uploadedDocs.length === 0) return;

    this.uploadedDocsBatch = uploadedDocs;
  }

  /* ================= SAVE ================= */

  onSaveUpload() {

    if (!this.uploadedDocsBatch.length) return;

    const mappedDocs: RegistrationDocument[] =
      this.uploadedDocsBatch.map(d => ({
        id: d.id,
        documentName: d.name,
        registrationId: this.parentId,
        documentPath: d.path,
        createdBy: '',
        createdOn: new Date().toISOString(),
        modifiedBy: '',
        modifiedOn: new Date().toISOString(),
        editing: false
      }));

    this.added.emit(mappedDocs);

    this.onCancelUpload();
  }

  /* ================= DELETE ================= */

  deleteDocument(id: string) {
    this.deleteRequested.emit(id);
  }





  getDocPath(doc: any): string {
    return Utilities.getAzureUrl(doc);
  }

  viewDocument(doc: any) {
    window.open(this.getDocPath(doc), '_blank');
  }
  editDocument(doc: any) {
    this.documents.forEach(d => {
      d.editing = false; 
      d.documentNameError = false; // Code added by Sanchit on 09/08/2026
    });
    doc.editDocumentName = doc.documentName;
    doc.documentNameError = false; // Code added by Sanchit on 09/08/2026
    doc.editing = true;
  }

  cancelEdit(doc: any) {
    delete doc.editDocumentName;
    doc.documentNameError = false; // Code added by Sanchit on 09/08/2026
    doc.editing = false;
  }

  saveDocument(doc: any) {
    // Start Code edited by Sanchit on 09/08/2026
    const documentName = (doc.editDocumentName ?? '').trim();

    if (!documentName) {
      doc.documentNameError = true;
      return;
    }

    doc.documentName = documentName;
    delete doc.editDocumentName;
    doc.documentNameError = false;
    // End Code edited by Sanchit on 09/08/2026
    doc.editing = false;
    this.saved.emit(doc);
  }

}

